import { Entity, Field } from "typegraph";

@Entity({ one: "forum", many: "forums" })
export default class Forum
{
	@Field()
	public id: number;

	@Field()
	public name: string;
}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/Forum.ts